import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { KieneBackendApiService } from '../backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../kiene-core.config';
import { Observable, Subject } from 'rxjs';
import { KieneSession } from '../local-storage/kiene-session';
import { UserCredentials } from '../../components/client/classes/user';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class LoginService {
    constructor(
        private http: HttpClient,
        private api: KieneBackendApiService,
        private localStorageService: LocalStorageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    login(userCredentials: UserCredentials): Observable<KieneSession> {
        userCredentials.trim();
        return this.http.post<KieneSession>(this.apiBaseUrl + 'session/create.php', userCredentials);
    }

    logout() {
        return this.http.post(this.apiBaseUrl + 'session/delete.php', null);
    }

    sendePasswortResetEmail(email: string): Observable<any> {
        const emailJson = { email: email };
        return this.api.post(this.apiBaseUrl + 'benutzer/vergessen.php', emailJson, null);
    }

    resetPasswort(token: string, passwort: string): Observable<any> {
        const passwortJson = { pw_zuruecksetzen_id: token, passwort: passwort };
        return this.api.post(this.apiBaseUrl + 'benutzer/passwort_reset.php', passwortJson, null);
    }

    validierePasswortResetToken(token: string): Observable<any> {
        const params = new HttpParams().set('pw_zuruecksetzen_id', token);
        return this.api.get(this.apiBaseUrl + 'benutzer/reset_token_validation.php', params);
    }

    reloadSession(): Observable<boolean> {
        const sub = new Subject<boolean>();
        this.api.post(this.apiBaseUrl + 'session/refresh.php', undefined).subscribe({
            next: (session: KieneSession) => {
                this.localStorageService.setCurrentUser(session);
                this.localStorageService.setCurrentClient(null, 'LoginService');
                sub.next(true);
            },
            error: () => {
                sub.next(false);
            },
        });
        return sub;
    }
}
